<div class="even">
    <mat-label class="subHeading">Multi-Year<span *ngIf="isRequired" class="star">*</span></mat-label>
<!-- <button class="side" (click)="form.controls['premium_base'].setValue(null)">Remove</button> -->
</div>
<mat-select formControlName="multi_year" class="premium" placeholder="{{isRequired ? 'Select' : 'All'}}">
    <mat-option *ngFor="let multiYear of multiYearTypes" [value]="multiYear.isDefault">{{multiYear.viewValue}}</mat-option>
</mat-select>